export { IconsHouse1 } from "./IconsHouse1";
